const getLanguage = (url) => {
  const hasBR = url.includes('?language=pt-br') || url.includes('ondivan-staging.web.app') || url.includes('.com.br');
  return hasBR ? 'pt-BR' : 'pt';
  // return'pt-BR'
};
export default getLanguage;
